import rules from '@/libs/rules'

export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        dataSource: {
            type: Object | Array,
            default: () => {
                return {};
            }
        }
    },
    data() {
        return {
            rules,
            currValue: this.value,
            loading: false,
            // 表单数据
            formData: {},
        }
    },
    methods: {
        // 加载表单数据
        setFormData() {
            throw new Error(`missing method 'setFormData' at thirdApi`);
        },
    },
    watch: {
        value(val) {
            // 加载窗口
            if (this.currValue !== val) {
                this.currValue = val;
            }
            if (val) {// 加载表单数据
                val && this.setFormData()

                /*this.$nextTick(()=>{
                    ;this.$refs.form && this.$refs.form.resetFields()
                })*/
            }

        },
        currValue(val) {
            // 关闭窗口
            if (!val && this.value !== val) {
                this.$refs.form && this.$refs.form.resetFields()
                this.$nextTick(()=> {
                    this.$emit('input', false);
                })
                /*if (this.$refs.form) {
                    setTimeout(() => {
                        this.$refs.form.resetFields();
                        setTimeout(() => {
                            this.$refs.form.resetFields();
                        }, 10);
                    }, 200);
                }*/
            }
        },
        dataSource: {
            handler: function (val) {
                this.setFormData();
            },
            deep: true
        }
    }
}
